enum LogName {
    PRECV = 'PRECV',
    CLICK = 'CLICK'
}

export default LogName;
